import axios from "axios"
import { del, get, post, put } from "./api_helper"
import { getAccessToken } from "./jwt-token-access/accessToken"

const API_BASE_URL = `${process.env.REACT_APP_API_INT_LEADS}/api`

const authHeader = () => ({
  headers: { "x-access-token": getAccessToken() },
})

// ─── Seguradoras ─────────────────────────────────────────────────────────────

export const getSeguradoras = () =>
  get(`${API_BASE_URL}/seguradoras`, authHeader())

export const getSeguradoraById = id =>
  get(`${API_BASE_URL}/seguradoras/${id}`, authHeader())

export const createSeguradora = ({ Nome, Cnpj, CodigoSusep }) =>
  post(`${API_BASE_URL}/seguradoras`, { Nome, Cnpj, CodigoSusep }, authHeader())

export const updateSeguradora = (id, { Nome, Cnpj, CodigoSusep }) =>
  put(`${API_BASE_URL}/seguradoras/${id}`, { Nome, Cnpj, CodigoSusep }, authHeader())

export const deleteSeguradora = id =>
  del(`${API_BASE_URL}/seguradoras/${id}`, authHeader())

// ─── Templates ───────────────────────────────────────────────────────────────

export const getTemplatesBySeguradora = seguradoraId =>
  get(`${API_BASE_URL}/seguradoras/${seguradoraId}/templates`, authHeader())

export const createTemplate = (seguradoraId, formData) =>
  axios.post(`${API_BASE_URL}/seguradoras/${seguradoraId}/templates`, formData, {
    headers: { "x-access-token": getAccessToken() },
  }).then(r => r.data)

export const updateTemplate = (seguradoraId, templateId, formData) =>
  axios.put(`${API_BASE_URL}/seguradoras/${seguradoraId}/templates/${templateId}`, formData, {
    headers: { "x-access-token": getAccessToken() },
  }).then(r => r.data)

export const deleteTemplate = (seguradoraId, templateId) =>
  del(`${API_BASE_URL}/seguradoras/${seguradoraId}/templates/${templateId}`, authHeader())

export const setTemplateAtivo = (seguradoraId, templateId) =>
  put(
    `${API_BASE_URL}/seguradoras/${seguradoraId}/templates/${templateId}/ativo`,
    {},
    authHeader()
  )
